import { Box, Flex, List, ListIcon, ListItem } from "@chakra-ui/react"
import Rocket from "@components/animations/Rocket"
import { BenefitsData } from "@data/benefits"
import SvgListIcon from "@public/svg/misc/list-icon.svg"
import { useRouter } from "next/router"
import { useTranslations } from "next-intl"

export default function Benefits() {
  const { locale } = useRouter()
  const t = useTranslations("home.benefits")
  return (
    <Flex
      flexDirection={{ base: "column", lg: "row" }}
      justify={"space-between"}
      alignItems={"center"}
      overflow={"hidden"}
    >
      <List spacing={5}>
        {BenefitsData.map((benefit, index) => (
          <ListItem
            key={index}
            color={"brand.black"}
            py={2}
          >
            <ListIcon
              as={SvgListIcon}
              transform={locale === "ar" ? "scaleX(-1)" : "scaleX(1)"}
              color={"brand.gray"}
              me={{ base: 2, md: 6 }}
              w={4}
              height={4}
            />
            <Box
              as={"span"}
              color={"brand.secondary"}
              fontWeight={"500"}
              fontSize={{ base: "md", md: "lg" }}
              textTransform={"capitalize"}
            >
              {t(benefit.title)}
            </Box>
            <Box ms={{ base: 6, md: 10 }}>{t(benefit.description)}</Box>
          </ListItem>
        ))}
      </List>
      <Rocket locale={locale} />
    </Flex>
  )
}
